import { render } from "./RegisterStatisticView.vue?vue&type=template&id=16e07763&scoped=true"
import script from "./RegisterStatisticView.vue?vue&type=script&lang=js"
export * from "./RegisterStatisticView.vue?vue&type=script&lang=js"

import "./RegisterStatisticView.vue?vue&type=style&index=0&id=16e07763&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e07763"]])

export default __exports__